<template>
  <div class="describe">
    <slot name="month"> </slot>
    <slot name="date"></slot>
    <slot name="day"></slot>
    <slot name="recent">
      <!-- <span class="tomr">明天</span> -->
    </slot>
  </div>
</template>

<script>
export default {};
</script>

<style>
.describe {
  padding: 2rem;
  height: auto;
  flex: 0 1;
}

.month {
  color: #999 !important;
  font-size: 1.6rem;
  line-height: 22px;
  letter-spacing: 0;
}

.date {
  margin-top: 5px;
  margin-bottom: 5px;
  color: #333;
  font-weight: 700;
  font-size: 2.2rem;
  line-height: 2.2rem;
  letter-spacing: 0;
}

.day {
  color: #999 !important;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 0;
}

.recent {
  height: 1.5rem;
  width: 100%;
}

.recent span {
  display: block;
  max-width: 4.8rem;
  margin-top: 0.2rem;
  line-height: 1;
  padding: 0.3rem 1rem;
  color: #fff;
  border-radius: 10rem;
  text-align: center;
}

.tomr {
  background-color: #eeca72;
}

.dat {
  background-color: #f2637b;
}

.today {
  background-color: #3aa1ff;
}

.yest {
  background-color: #4ecb73;
}

.dby {
  background-color: #36cbcb;
}
</style>
